module.exports = __webpack_public_path__ + "static/media/ModalBanner.84f49d45.jpg";